import { doubleTabsModalActionTypes } from '@/components/modals/doubleTabsModal/Constants';

export function toggleDoubleTabsModal(open: boolean) {
	return {
		type: doubleTabsModalActionTypes.TOGGLE_DOUBLE_TABS_MODAL,
		payload: {
			open,
		},
	};
}
